<template>
  <a-modal title="新增体检单项" :width="900" :visible="visible"
           :confirmLoading="confirmLoading" :destroyOnClose="true" :maskClosable="false"
           @ok="handleSubmitOk"
           @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item label="体检科室" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
        <a-select placeholder="请选择体检科室" v-decorator="['baMedicalDepartmentId', {rules: [{required: true, message: '请选择体检科室'}]}]"
                  show-search :filter-option="handleDeptFilterOption" :options="examDeptList"
        />
      </a-form-item>

      <a-form-item label="项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
        <a-input placeholder="请输入项目名称" v-decorator="['projectName', {rules: [{required: true, message: '请输入项目名称'}]}]" />
      </a-form-item>

      <a-form-item label="项目价格" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
        <a-input-number style='width: 100%'  placeholder="请输入项目价格" v-decorator="['projectPrice', {rules: [{required: true, message: '请输入项目价格'}]}]" :min="0"/>
      </a-form-item>

      <a-form-item label="项目编码" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
        <a-input placeholder="请输入项目编码" v-decorator="['projectNum', {rules: [{required: true, message: '请输入项目编码'}]}]" />
      </a-form-item>

      <a-form-item label="性别限定" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
        <a-select placeholder="请选择性别限定" v-decorator="['gender', {rules: [{required: true, message: '请选择性别限定'}]}]">
          <a-select-option key='1' value="1">适用男性</a-select-option>
          <a-select-option key='2' value="2">适应女性</a-select-option>
          <a-select-option key='3' value="3">不限</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
  import {qryExamDeptList, addExamProject} from '@/api/modular/interhospital/subItems/subItems';

  /**
   * @Description: 体检单项新增
   */
  export default {
    data() {
      return {
        form: this.$form.createForm(this),

        labelCol: {xs: {span: 24}, sm: {span: 5}},
        wrapperCol: {xs: {span: 24}, sm: {span: 15}},

        confirmLoading: false,
        visible: false,

        examDeptList: [], // 体检科室
      }
    },

    methods: {
      // 初始化方法
      add() {
        this.visible = true;
        this.handleGetExamDeptList();
      },

      // 获取体检科室信息
      handleGetExamDeptList() {
        qryExamDeptList().then(res => {
          if (res.code == 200) {
            this.examDeptList = [];

            res.data.map(item => this.examDeptList.push({value: item.deptId, label: item.deptName}));
          } else {
            this.$message.error(res.message)
          }
        });
      },
      // 过滤筛选体检科室
      handleDeptFilterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },


      // 点击提交
      handleSubmitOk() {
        const {form: {validateFields}} = this;
        this.confirmLoading = true;

        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key]);
              }
            }

            addExamProject(values).then((res) => {
              if (res.code == 200) {
                this.$message.success('新增成功');
                this.confirmLoading = false;
                this.$emit('ok', values);
                this.handleCancel();

              } else {
                this.$message.error('新增失败')
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            this.confirmLoading = false;
          }
        })
      },

      // 关闭modal框
      handleCancel() {
        this.form.resetFields();
        this.visible = false;
      },

    },
  }
</script>

<style lang="less" scoped>
  /deep/ .ant-form-item-label{
    text-overflow: ellipsis;
  }

  .ant-calendar-picker-container{
    z-index: 2000;
  }
</style>
